import { useEffect } from 'react';

import { env } from '@neo.tax/shared/utils';

/**
 * Sends one request to the backend when a sign-in page mounts, so a backend scaled to zero starts an instance
 * while the user is still on the page. Firebase allows its sign-in blocking function only seven seconds, which a
 * cold start can exceed. The response is never read and a failure is ignored: the request only exists to be
 * received.
 */
export const useWakeBackend = (): void => {
  useEffect(() => {
    (async (): Promise<void> => {
      try {
        await fetch(`${env.REACT_APP_BACKEND_BASE_URL}/health/live`);
      } catch {
        // An unreachable backend has nothing to wake.
      }
    })();
  }, []);
};
